import { render } from "./WeddingInvitationEditForm.vue?vue&type=template&id=6cbef220"
import script from "./WeddingInvitationEditForm.vue?vue&type=script&lang=js"
export * from "./WeddingInvitationEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__